// Generated from src/img/svg/s3.svg

export const S3 = (props) => {
  return (
    <svg viewBox="0 0 26 13" {...props}>
      <rect fill="#941c81" height="13" rx="6.5" width="25" x=".5" />
      <g
        aria-label="S3"
        style={{
          fill: "#fff",
          fontFamily: 'HelveticaNeue-Bold,"Helvetica Neue",sans-serif',
          fontSize: "10px",
          fontWeight: "700",
          transform: "translate(.5px,0)",
        }}
      >
        <path d="M6.715 7.63h1.52q0 .67.48 1.02.41.3 1.1.3.54 0 .9-.17.49-.23.49-.72 0-.61-1.1-.92-1.9-.54-2.05-.62-1.1-.53-1.1-1.67 0-1.03.85-1.63.76-.53 1.82-.53 1.23 0 1.99.53.87.61.87 1.77h-1.52q-.06-1.08-1.41-1.08-.43 0-.73.18-.35.22-.35.63 0 .39.39.57.3.14 1.74.51.84.21 1.25.48.87.56.87 1.6 0 1.02-.76 1.64-.8.65-2.21.65-1.29 0-2.12-.61-.93-.69-.92-1.93M15.245 6.83v-1q.58.05.97-.12.52-.21.52-.75 0-.43-.29-.68t-.7-.25q-.52 0-.81.35-.28.34-.27.9h-1.35q.04-1.08.69-1.75.66-.67 1.73-.67.91 0 1.6.5.75.56.75 1.44 0 .52-.25.89-.26.41-.73.54v.02q.57.13.9.57.34.43.34 1.02 0 1.06-.79 1.7-.73.6-1.81.6-1.2 0-1.91-.68t-.69-1.87h1.35q.02.61.32.97.32.41.91.41.49 0 .81-.3.33-.31.33-.8 0-.7-.55-.92-.31-.12-1.07-.12" />
      </g>
    </svg>
  );
};
